<template>
   <div id="group-layout-page-container">
      <Aside />
      <Main>
         <Navbar />

         <div class="container">
            <div class="columns">
               <div class="column is-12">
                  <div id="group-layout-wrapper">
                     <aside class="sub-menu">
                        <RouterLink to="/group/flight/new" active-class="active" exact>
                           <!-- <Icon name="tickets-plane" /> -->
                           {{ $t("groupLayout_newFlightRequest") }}
                        </RouterLink>
                        <a v-if="hasLastTaskValue" href="#" @click.prevent="goToLastTask" :class="{ active: isTaskLogsPage }">{{ $t("groupLayout_myActiveRequests") }}</a>
                        <RouterLink to="/group/flight/tasks" active-class="active" exact>{{ $t("groupLayout_requestList") }}</RouterLink>
                     </aside>

                     <main class="content-card">
                        <RouterView />
                     </main>
                  </div>
               </div>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import Main from "@/components/unitary/Main.vue";
import { useRecentTasks } from "@/composables/useRecentTasks.js";

export default {
   name: "GroupLayout",
   components: {
      Aside,
      Navbar,
      Main,
   },
   data() {
      return {
         hasLastTaskValue: false,
         cookieCheckInterval: null,
      };
   },
   computed: {
      isTaskLogsPage() {
         return this.$route.name === "TaskLogs" || this.$route.name === "MyActiveTasks";
      },
   },
   mounted() {
      this.checkLastTask();
   },
   watch: {
      $route() {
         // Check when route changes
         this.checkLastTask();
      },
   },
   created() {
      // Check periodically for cookie changes (every 2 seconds)
      this.cookieCheckInterval = setInterval(() => {
         this.checkLastTask();
      }, 2000);
   },
   beforeDestroy() {
      if (this.cookieCheckInterval) {
         clearInterval(this.cookieCheckInterval);
      }
   },
   methods: {
      checkLastTask() {
         const { hasLastTask } = useRecentTasks();
         this.hasLastTaskValue = hasLastTask();
      },
      goToLastTask() {
         // Navigate to My Active Tasks page
         this.$router.push("/group/flight/my-active-tasks");
      },
   },
};
</script>

<style lang="scss" scoped>
.sub-menu {
   display: flex;
   flex-direction: column;
   background-color: var(--container-bg);
   padding: 2rem 1rem;
   border-radius: 1rem;
   height: fit-content;

   a {
      text-align: left;
      //       border: 1px solid;
      padding: 0.85rem 1rem;
      border-radius: 0.5rem;
      min-width: 200px;
      color: var(--primary) !important;
      display: flex;
      align-items: center;
      gap: 0.5rem;
   }

   .active {
      background-color: var(--gray-100);
      font-weight: 500;
   }
}

.content-card {
   background-color: var(--container-bg);
   padding: 1.5rem;
   border-radius: 1rem;
   width: 100%;

   @media (min-width: 992px) {
      padding: 2.5rem 3rem;
   }
}
#group-layout-page-container {
   #group-layout-wrapper {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      @media (min-width: 992px) {
         flex-direction: row;
      }
   }
}
</style>
